export const filter = (filter, filterAccessor, array, onlyFilterFromStart = false) => {
  if (filter && filter.length > 0) {
    if (!filterAccessor) {
      console.error('No filter accessor defined!')
    } else {
      array = array.filter(c => {
        // Ensure filter items are an array
        let filterItems = filterAccessor(c)
        if (!(filterItems instanceof Array)) {
          filterItems = [filterItems]
        }

        if (onlyFilterFromStart) {
          return filterItems.some(i => {
            return ('' + i).toLowerCase().startsWith(filter.toLowerCase())
          })
        } else {
          return filterItems.some(i => {
            return ('' + i).toLowerCase().includes(filter.toLowerCase())
          })
        }
      })
    }
  }
  return array
}



// WEBPACK FOOTER //
// ./src/components/App/filterService.js